import { useEffect, useState } from 'react';

import { searchSisStudents } from '../../../api/services/SisImport';
import { SisStatus } from '../../RiderCreationModal/SisImportBanner';

export const useSisImportStatus = (sisEnabled: boolean): SisStatus | null => {
  const [sisStatus, setSisStatus] = useState<SisStatus | null>(null);

  useEffect(() => {
    if (!sisEnabled) {
      return;
    }

    searchSisStudents('').then((response) => {
      if (response.type === 'success') {
        setSisStatus(response.data.students.length === 0 ? 'no-records' : 'available');
      }
    });
  }, [sisEnabled]);

  return sisStatus;
};
